import { Dialog, DialogContent } from "@/shared"
import { useTranslation } from "react-i18next";

const InvoiceTotalsDialog = ({ totalsByType, viewTotals, setViewTotals }: any) => {
    const { t } = useTranslation();
    return (
        <Dialog open={viewTotals} onOpenChange={() => { setViewTotals(!viewTotals) }}>
            <DialogContent onClose={() => { setViewTotals(!viewTotals) }}>
                {viewTotals && (
                    <tfoot className="bg-slate-50">
                        {Object.entries(totalsByType).map(([type, total]: any) => (
                            <tr key={type} className="border-b border-slate-100 last:border-none">
                                <td colSpan={4} className="px-6 py-2"></td>
                                <td className="px-6 py-2 text-xs font-bold text-slate-500 bg-slate-100/50">
                                    <span className="block uppercase">{t("Total")}  {t(type)}</span>
                                </td>
                                <td className="px-6 py-2 text-sm font-black text-slate-800 bg-slate-100/50">
                                    {Number(total || 0).toFixed(2)}
                                </td>
                            </tr>
                        ))}
                    </tfoot>
                )}
            </DialogContent>
        </Dialog>
    )
}

export default InvoiceTotalsDialog;